import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createSelector } from 'reselect';
import { drillUp, selectCompareMode } from '@store/summaryContainer/drilldown/actions';
import { applyFilter, updateInterval, toggleModal, updateGranularity } from '@store/common/actions';
import { exportData } from '@store/export/actions';
import { selectedMetricChart } from '@store/metricsChartContainer/actions';
import {
  setComparisonInterval,
  setComparisonUnavailable,
} from '@store/summaryContainer/comparison/actions';
import { toggleNewComparisonDashboard, addMetric } from '@store/comparison/actions';
import { setMetrics } from '@store/summaryContainer/meta/actions';
import { selector as commonSelector } from '@store/common';
import { selector as summaryContainerSelector } from '@store/summaryContainer';
import { selector as summaryComparisonSelector } from '@store/summaryContainer/comparison';
import { selector as summaryContainerMetaSelector } from '@store/summaryContainer/meta';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { dimensionsListSelector } from '@store/common/dimensionList/selectors';
import { sharingSelector } from '@src/store/trends/sharing/selectors';
import {
  newTrendsLayoutFeatureSelector,
  presetFidSelector,
  horizontalLayoutSelector,
} from '@store/common/selectors';
import { selectors as sharedTabsSelector, deleteSharedTab } from '@src/store/sharedTabs';
import { nocDrawerShowSelector } from '@store/noc/drawer/selectors';
import { modeSelector } from '@store/trends/selectors';
import SummaryContainer from './SummaryContainer';

const selector = createSelector(
  commonSelector,
  summaryContainerSelector,
  summaryComparisonSelector,
  summaryContainerMetaSelector,
  nocDrawerShowSelector,
  selectedMetricSelector,
  sharingSelector,
  dimensionsListSelector,
  sharedTabsSelector,
  presetFidSelector,
  newTrendsLayoutFeatureSelector,
  modeSelector,
  horizontalLayoutSelector,
  (
    commonStore,
    summaryContainerStore,
    comparisonStore,
    metaStore,
    nocDrawerShow,
    selectedMetric,
    sharingState,
    dimensionsList,
    sharedTabsStore,
    presetFid,
    newTrendsLayout,
    trendsMode,
    horizontalLayout,
  ) => ({
    interval: commonStore.interval,
    filters: commonStore.appliedFilters,
    compareMode: commonStore.compareMode,
    modal: commonStore.modal,
    features: commonStore.features,
    collapseStatus: commonStore.collapseStatus,
    drilldown: summaryContainerStore.drilldown,
    comparison: comparisonStore,
    loading: metaStore.loading || comparisonStore.meta.loading,
    error: metaStore.error,
    metrics: metaStore.metrics,
    selectedMetric,
    sharingState,
    dimensionsList,
    sharedTabs: sharedTabsStore.tabs,
    presetFid,
    nocDrawerShow,
    newTrendsLayout,
    mode: trendsMode.mode,
    horizontalLayout,
  }),
);

export default connect(selector, {
  selectCompareMode,
  applyFilter,
  updateInterval,
  drillUp,
  setComparisonInterval,
  setComparisonUnavailable,
  toggleNewComparisonDashboard,
  addMetric,
  toggleModal,
  deleteSharedTab,
  exportData,
  setMetrics,
  selectedMetricChart,
  updateGranularity,
})(withRouter(SummaryContainer));
